<style lang="scss" >
.reciveoffer .ivu-table-tip{
    overflow-x: hidden
}
.expandIcon {
    font-size: 16px;
    border: 1px solid #e2e8f0;
    margin-right: 10px
}

.reciveoffer td.ivu-table-expanded-cell{
    padding: 0px !important;
    border: none !important
}

.reciveoffer td.ivu-table-expanded-cell .ivu-table-wrapper-with-border{
    border: none !important
}
</style>
<template>
	<div class="reciveoffer">
        <div class="text-right" v-if="type === 'query'">
            <Button style="margin-bottom: 6px" @click="close">返回</Button>
        </div>
        <compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" :expand="false">
            <compFormQuery v-if="type=='query'" :formdata="getBase" :value="formData" :labelWidth="350"></compFormQuery>
            <compFormEdit v-else class="margin-15 clearfix" ref="baseform" :formdata="getBase" v-model="formData" :labelWidth="150" />
        </compWrapper>
        <compWrapper v-if = "type == 'query'" :title="$t('erp.channel.price_info',{defaultValue:'价格信息'})" :expand="false">
            <div class="margin-15">
                <div class="margin-bottom-15">
                    <span style="font-weight:bolder; cursor: pointer" @click="showWork=!showWork"><Icon class="expandIcon" :type="showWork ? 'ios-remove' : 'ios-add'" />作业费</span>
                </div>
                <div v-show="showWork" class="margin-bottom-15">
                    <Button v-if="isShowDetail" @click="showDetail">全部展开</Button>
                    <Button v-else @click="showDetail">全部折叠</Button>
                </div>
                <!-- <Table v-show="showWork" row-key="id" max-height="400" :columns="columns1" :data="workData" size="small" :span-method="handleSpan" border></Table> -->
                <Table v-show="showWork" max-height="400" :columns="columns1" :data="workData" size="small" :span-method="handleSpan" border></Table>
            </div>
            <div class="margin-15">
                <div class="margin-bottom-15">
                    <span style="font-weight:bolder; cursor: pointer" @click="showStorage=!showStorage"><Icon class="expandIcon" :type="showStorage ? 'ios-remove' : 'ios-add'" />仓储费</span>
                </div>
                <Table v-if="showStorage" max-height="400" :columns="columns2" :data="storageData" size="small" border ></Table>
            </div>
            <div class="margin-15">
                <div class="margin-bottom-15">
                    <span style="font-weight:bolder; cursor: pointer" @click="showAdded=!showAdded"><Icon class="expandIcon" :type="showAdded ? 'ios-remove' : 'ios-add'" />增值费</span>
                </div>
                <Table v-if="showAdded" max-height="400" :columns="columns3" :data="addedData" size="small" border ></Table>
            </div>
        </compWrapper>
        <compWrapper v-if="type==='query'" :title="$t('global.log.name',{defaultValue:'操作历史'})" >
			<vTable class="margin-15" :columns="getLogColumns" :data="logList" border></vTable>
		</compWrapper>
        <div class="text-right" v-if="type !== 'query'">
            <Button type="primary" @click="submit">确认</Button>
            <Button class="margin-left-10" @click="close">取消</Button>
        </div>
		<vLoading size="large" fix :loading="loading"></vLoading>
	</div>
</template>
<script>
import { HttpSaveCostQuotation, HttpCostQuotationDetail } from '@/service/tasks';
import { HttpProductList } from '@mods/service/dictionary';
import { mapGetters } from 'vuex';
import mixin from '../mixin';
export default {
	mixins: [mixin],
    props: [ 'querytype', 'activeids', ],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormEdit: () => import('@components/templates/formedit'),
	},
	data() {
		return {
            id: this.$route.query.id || this.activeids,
            type: this.$route.params.type || this.querytype,
			loading: false,
			formData: {},
            showWork: true,
            showStorage: false,
            showAdded: false,
            isShowDetail: false,
            workData: [],
            storageData: [],
            addedData: [],
            lineList: [],
			logList: [],
		};
	},
	created() {
        this.getDetail();
	},
	computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getAdminTransferWarehouse']),
		getBase() {
			return [
                {
                    label: this.$t('erp.b2c.product_orgwarehouse', { defaultValue: "仓库" }),
                    key: 'warehouse',
                    tag: 'vSelect',
                    options: this.warehouseList ,
                    props: {
                        filterable: true,
                    },
                    query: this.type !== 'add',
                },
                {
                    label: "作业费报价模板",
                    key: 'billingOperationPriceTemplateId',
                    tag: 'Select',
                    options: this.workListPay.map(item=>{
                        return {value: item.id, label: `${item.code}(${item.name})`}
                    }),
                    props: {
                        filterable: true,
                    },
                    required: false,
                    show: this.type !== 'query'
                },
                {
                    label: "作业费报价模板",
                    render: ()=>{
                        let template = this.workListPay.filter( item => item.id === this.formData.billingOperationPriceTemplateId);
                        if(template.length > 0){
                            return <div>{`${template[0].code}(${template[0].name})`}</div>
                        }else{
                            return <div>--</div>
                        }
                    },
                    show: this.type === 'query'
                },
                {
                    label: "仓储费报价模板",
                    key: 'billingStoragePriceTemplateId',
                    tag: 'Select',
                    options: this.storageListPay.map(item=>{
                        return {value: item.id, label: `${item.code}(${item.name})`}
                    }),
                    props: {
                        filterable: true,
                    },
                    required: false,
                    show: this.type !== 'query'
                },
                {
                    label: "仓储费报价模板",
                    render: ()=>{
                        let template = this.storageListPay.filter( item => item.id === this.formData.billingStoragePriceTemplateId);
                        if(template.length > 0){
                            return <div>{`${template[0].code}(${template[0].name})`}</div>
                        }else{
                            return <div>--</div>
                        }
                    },
                    show: this.type === 'query'
                },
                {
                    label: "增值费报价模板",
                    key: 'billingValueAddedPriceTemplateId',
                    tag: 'Select',
                    options: this.addedListPay.map(item=>{
                        return {value: item.id, label: `${item.code}(${item.name})`}
                    }),
                    props: {
                        filterable: true,
                    },
                    required: false,
                    show: this.type !== 'query'
                },
                {
                    label: "增值费报价模板",
                    render: ()=>{
                        let template = this.addedListPay.filter( item => item.id === this.formData.billingValueAddedPriceTemplateId);
                        if(template.length > 0){
                            return <div>{`${template[0].code}(${template[0].name})`}</div>
                        }else{
                            return <div>--</div>
                        }
                    },
                    show: this.type === 'query'
                },
                {
                    label: "有效期",
                    key:'effectTime',
                    tag: "vDatepicker",
                    props: {
                        options: this.options,
                        format: "yyyy-mm-dd ~ yyyy-mm-dd",
                        confirm: false,
                    },
                }
			]
		},
        columns1() {
            return [
                // {
                //     title: "单据类型",
                //     key: 'type',
                //     tree: true
                // },
                {
                    type: 'expand',
                    width: 50,
                    render: (h, {row}) => {
                        return <Table border size="small" columns={this.workItemcolumns} show-header={false} data={row.children1 || []}></Table>
                    },
                },
                {
                    title: "code",
                    key: 'billingCategoryCode',
                    tree: true,
                    render: ( h, {row}) => {
                        return <span>{row.billingCategoryCode || '--'}</span>
                    },
                    width: 130,
                },
                {
                    title: "计费项目",
                    key: 'billingCategoryName',
                    render: ( h, {row}) => {
                        return <div>{row.billingCategoryName || '--'}</div>
                    },
                    width: 130,
                },
                {
                    title: "计费单位",
                    key: 'billingUnit',
                    render: ( h, {row}) => {
                        const unit = this.billUnitEnum.filter(item=>{ return item.value === row.billingUnit })[0].label || '--'
                        return <div>{unit}</div>
                    },
                    width: 90,
                },
                {
                    title: "规则名称",
                    key: 'description',
                    render: ( h, {row}) => {
                        return <div>{row.names || '--'}</div>
                    }
                },
                {
                    title: "规则分组",
                    key: 'groupName',
                    render: ( h, {row}) => {
                        return <div>{row.groupName || '--'}</div>
                    },
                    width: 90,
                },
                {
                    title: "约束条件",
                    key: 'billingCondition',
                    render: ( h, {row}) => {
                        let oneData = this.billConditionEnum.filter(item => item.value == row.billingCondition)
                        if(oneData.length > 0){
                            return <div>{oneData[0].label}</div>
                        }else{
                            return <div>--</div>
                        }
                    }
                },
                {
                    title: "公式",
                    key: 'billingCategoryFormula',
                    render: ( h, {row}) => {
                        let formula = row.billingCategoryFormula || '--';
                        return  formula.length < 100 ? <Tooltip placement="top" content={formula} max-width="200">
                            <div>
                                {formula.length > 20 ? formula.slice(0,20).concat('...') : formula}
                            </div>
                        </Tooltip>:<div>
                                {formula.length > 20 ? formula.slice(0,20).concat('...') : formula}
                            </div>
                    }
                },
                {
                    title: "单价",
                    key: 'price',
                    render: ( h, {row}) => {
                        return <div>{row.price || '--'}</div>
                    },
                    width: 80,
                },
                {
                    title: "最低收费",
                    key: 'minimumCharge',
                    render: ( h, {row}) => {
                        return <div>{row.minimumCharge || '--'}</div>
                    },
                    width: 90,
                },
                {
                    title: "最高收费",
                    key: 'maximumCharge',
                    render: ( h, {row}) => {
                        return <div>{row.maximumCharge || '--'}</div>
                    },
                    width: 90,
                },
                {
                    title: "生效日期",
                    key: 'startTime',
                    render: ( h, {row}) => {
                        return <div>{row.startTime || '--'}</div>
                    },
                    width: 100,
                },
                {
                    title: "失效日期",
                    key: 'endTime',
                    render: ( h, {row}) => {
                        return <div>{row.endTime || '--'}</div>
                    },
                    width: 100,
                },
                {
                    title: "创建人/创建时间",
                    render: (h, row)=>{
                        return <div>
                            <div>{row.row.createdName || '--'}</div>
                            <div>{row.row.createdAt || '--'}</div>
                        </div>
                    }
                },
                {
                    title: "更新人/更新时间",
                    render: (h, row)=>{
                        return <div>
                            <div>{row.row.updatedName || '--'}</div>
                            <div>{row.row.updatedAt || '--'}</div>
                        </div>
                    }
                },
            ]
        },
        workItemcolumns() {
            return [
                {
                    title: "单据类型",
                    key: 'type',
                    width: 50,
                    render: (h, {row}) => {
                        return <div></div>
                    }
                },
                {
                    title: "code",
                    key: 'billingCategoryCode',
                    tree: true,
                    render: ( h, {row}) => {
                        return <span>{row.billingCategoryCode || '--'}</span>
                    },
                    width: 130,
                },
                {
                    title: "计费项目",
                    key: 'billingCategoryName',
                    render: ( h, {row}) => {
                        return <div>{row.billingCategoryName || '--'}</div>
                    },
                    width: 130,
                },
                {
                    title: "计费单位",
                    key: 'billingUnit',
                    render: ( h, {row}) => {
                        const unit = this.billUnitEnum.filter(item=>{ return item.value === row.billingUnit })[0].label || '--'
                        return <div>{unit}</div>
                    },
                    width: 90,
                },
                {
                    title: "规则名称",
                    key: 'description',
                    render: ( h, {row}) => {
                        return <div>{row.names || '--'}</div>
                    }
                },
                {
                    title: "规则分组",
                    key: 'groupName',
                    render: ( h, {row}) => {
                        return <div>{row.groupName || '--'}</div>
                    },
                    width: 90,
                },
                {
                    title: "约束条件",
                    key: 'billingCondition',
                    render: ( h, {row}) => {
                        let oneData = this.billConditionEnum.filter(item => item.value == row.billingCondition)
                        if(oneData.length > 0){
                            return <div>{oneData[0].label}</div>
                        }else{
                            return <div>--</div>
                        }
                    }
                },
                {
                    title: "公式",
                    key: 'billingCategoryFormula',
                    render: ( h, {row}) => {
                        let formula = row.billingCategoryFormula || '--';
                        return  formula.length < 100 ? <Tooltip placement="top" content={formula} max-width="200">
                            <div>
                                {formula.length > 20 ? formula.slice(0,20).concat('...') : formula}
                            </div>
                        </Tooltip>:<div>
                                {formula.length > 20 ? formula.slice(0,20).concat('...') : formula}
                            </div>
                    }
                },
                {
                    title: "单价",
                    key: 'price',
                    render: ( h, {row}) => {
                        return <div>{row.price || '--'}</div>
                    },
                    width: 80,
                },
                {
                    title: "最低收费",
                    key: 'minimumCharge',
                    render: ( h, {row}) => {
                        return <div>{row.minimumCharge || '--'}</div>
                    },
                    width: 90,
                },
                {
                    title: "最高收费",
                    key: 'maximumCharge',
                    render: ( h, {row}) => {
                        return <div>{row.maximumCharge || '--'}</div>
                    },
                    width: 90,
                },
                {
                    title: "生效日期",
                    key: 'startTime',
                    render: ( h, {row}) => {
                        return <div>{row.startTime || '--'}</div>
                    },
                    width: 100,
                },
                {
                    title: "失效日期",
                    key: 'endTime',
                    render: ( h, {row}) => {
                        return <div>{row.endTime || '--'}</div>
                    },
                    width: 100,
                },
                {
                    title: "创建人/创建时间",
                    render: (h, row)=>{
                        return <div>
                            <div>{row.row.createdName || '--'}</div>
                            <div>{row.row.createdAt || '--'}</div>
                        </div>
                    }
                },
                {
                    title: "更新人/更新时间",
                    render: (h, row)=>{
                        return <div>
                            <div>{row.row.updatedName || '--'}</div>
                            <div>{row.row.updatedAt || '--'}</div>
                        </div>
                    }
                },
            ]
        },
        columns2() {
            return [
                {
                    title: "code",
                    key: 'billingCategoryCode',
                    render: ( h, {row}) => {
                        return <span>{row.billingCategoryCode || '--'}</span>
                    },
                    width: 130,
                },
                {
                    title: "计费项目",
                    key: 'billingCategoryName',
                    render: ( h, {row}) => {
                        return <div>{row.billingCategoryName || '--'}</div>
                    },
                    width: 130,
                },
                {
                    title: "计费单位",
                    key: 'billingUnit',
                    render: ( h, {row}) => {
                        const unit = this.billUnitEnum.filter(item=>{ return item.value === row.billingUnit })[0].label || '--'
                        return <div>{unit}</div>
                    },
                    width: 90,
                },
                {
                    title: "规则名称",
                    key: 'description',
                    render: ( h, {row}) => {
                        return <div>{row.names || '--'}</div>
                    }
                },
                {
                    title: "规则分组",
                    key: 'groupName',
                    render: ( h, {row}) => {
                        return <div>{row.groupName || '--'}</div>
                    },
                    width: 90,
                },
                {
                    title: "约束条件",
                    key: 'billingCondition',
                    render: ( h, {row}) => {
                        let oneData = this.billConditionEnum.filter(item => item.value == row.billingCondition)
                        if(oneData.length > 0){
                            return <div>{oneData[0].label}</div>
                        }else{
                            return <div>--</div>
                        }
                    }
                },
                {
                    title: "公式",
                    key: 'billingCategoryFormula',
                    render: ( h, {row}) => {
                        let formula = row.billingCategoryFormula || '--';
                        return  formula.length < 100 ? <Tooltip placement="top" content={formula} max-width="200">
                            <div>
                                {formula.length > 20 ? formula.slice(0,20).concat('...') : formula}
                            </div>
                        </Tooltip>:<div>
                                {formula.length > 20 ? formula.slice(0,20).concat('...') : formula}
                            </div>
                    }
                },
                {
                    title: "存储天数起",
                    key: 'attachValue',
                    render: ( h, {row}) => {
                        return <div>{row.attachValue || '--'}</div>
                    },
                    width: 100,
                },
                {
                    title: "存储天数止",
                    key: 'attachValue1',
                    render: ( h, {row}) => {
                        return <div>{row.attachValue1 || '--'}</div>
                    },
                    width: 100,
                },
                {
                    title: "单价",
                    key: 'price',
                    render: ( h, {row}) => {
                        return <div>{row.price || '--'}</div>
                    },
                    width: 80,
                },
                {
                    title: "最低收费",
                    key: 'minimumCharge',
                    render: ( h, {row}) => {
                        return <div>{row.minimumCharge || '--'}</div>
                    },
                    width: 90,
                },
                {
                    title: "最高收费",
                    key: 'maximumCharge',
                    render: ( h, {row}) => {
                        return <div>{row.maximumCharge || '--'}</div>
                    },
                    width: 90,
                },
                {
                    title: "生效日期",
                    key: 'startTime',
                    render: ( h, {row}) => {
                        return <div>{row.startTime || '--'}</div>
                    },
                    width: 100,
                },
                {
                    title: "失效日期",
                    key: 'endTime',
                    render: ( h, {row}) => {
                        return <div>{row.endTime || '--'}</div>
                    },
                    width: 100,
                },
                {
                    title: "创建人/创建时间",
                    render: (h, row)=>{
                        return <div>
                            <div>{row.row.createdName || '--'}</div>
                            <div>{row.row.createdAt || '--'}</div>
                        </div>
                    }
                },
                {
                    title: "更新人/更新时间",
                    render: (h, row)=>{
                        return <div>
                            <div>{row.row.updatedName || '--'}</div>
                            <div>{row.row.updatedAt || '--'}</div>
                        </div>
                    }
                },
            ]
        },
        columns3() {
            return [
                {
                    title: "code",
                    key: 'billingCategoryCode',
                    render: ( h, {row}) => {
                        return <span>{row.billingCategoryCode || '--'}</span>
                    },
                    width: 130,
                },
                {
                    title: "计费项目",
                    key: 'billingCategoryName',
                    render: ( h, {row}) => {
                        return <div>{row.billingCategoryName || '--'}</div>
                    },
                    width: 130,
                },
                {
                    title: "计费单位",
                    key: 'billingUnit',
                    render: ( h, {row}) => {
                        const unit = this.billUnitEnum.filter(item=>{ return item.value === row.billingUnit })[0].label || '--'
                        return <div>{unit}</div>
                    },
                    width: 90,
                },
                {
                    title: "规则名称",
                    key: 'description',
                    render: ( h, {row}) => {
                        return <div>{row.names || '--'}</div>
                    }
                },
                {
                    title: "规则分组",
                    key: 'groupName',
                    render: ( h, {row}) => {
                        return <div>{row.groupName || '--'}</div>
                    },
                    width: 90,
                },
                {
                    title: "约束条件",
                    key: 'billingCondition',
                    render: ( h, {row}) => {
                        let oneData = this.billConditionEnum.filter(item => item.value == row.billingCondition)
                        if(oneData.length > 0){
                            return <div>{oneData[0].label}</div>
                        }else{
                            return <div>--</div>
                        }
                    }
                },
                {
                    title: "公式",
                    key: 'billingCategoryFormula',
                    render: ( h, {row}) => {
                        let formula = row.billingCategoryFormula || '--';
                        return  formula.length < 100 ? <Tooltip placement="top" content={formula} max-width="200">
                            <div>
                                {formula.length > 20 ? formula.slice(0,20).concat('...') : formula}
                            </div>
                        </Tooltip>:<div>
                                {formula.length > 20 ? formula.slice(0,20).concat('...') : formula}
                            </div>
                    }
                },
                {
                    title: "单价",
                    key: 'price',
                    render: ( h, {row}) => {
                        return <div>{row.price || '--'}</div>
                    },
                    width: 80,
                },
                {
                    title: "最低收费",
                    key: 'minimumCharge',
                    render: ( h, {row}) => {
                        return <div>{row.minimumCharge || '--'}</div>
                    },
                    width: 90,
                },
                {
                    title: "最高收费",
                    key: 'maximumCharge',
                    render: ( h, {row}) => {
                        return <div>{row.maximumCharge || '--'}</div>
                    },
                    width: 90,
                },
                {
                    title: "生效日期",
                    key: 'startTime',
                    render: ( h, {row}) => {
                        return <div>{row.startTime || '--'}</div>
                    },
                    width: 100,
                },
                {
                    title: "失效日期",
                    key: 'endTime',
                    render: ( h, {row}) => {
                        return <div>{row.endTime || '--'}</div>
                    },
                    width: 100,
                },
                {
                    title: "创建人/创建时间",
                    render: (h, row)=>{
                        return <div>
                            <div>{row.row.createdName || '--'}</div>
                            <div>{row.row.createdAt || '--'}</div>
                        </div>
                    }
                },
                {
                    title: "更新人/更新时间",
                    render: (h, row)=>{
                        return <div>
                            <div>{row.row.updatedName || '--'}</div>
                            <div>{row.row.updatedAt || '--'}</div>
                        </div>
                    }
                },
            ]
        },
        getLogColumns() {
			return [
                {
                    title: this.$t('global.common.operator', { defaultValue: '操作人' }),
                    key: 'createdName',
                },
                {
                    title: this.$t('global.common.operate_type', { defaultValue: '操作类型' }),
                    key: 'opAction',
                    render: (h, { row }) => {
                        return this.getLogActions[row.operateType] || '';
                    },
                },
                {
                    title: this.$t('global.common.notes', { defaultValue: '备注' }),
                    key: 'remark',
                    width: "30%"
                },
                {
                    title: this.$t('global.common.operate_time', { defaultValue: '操作时间' }),
                    key: 'createdAt',
                },
            ];
		},
	},
	methods: {
        handleSpan ({ row, column, rowIndex, columnIndex }) {
            // if (row.children) {
            //     if( columnIndex == 0){
            //         return [1, 14];
            //     }else{
            //         return [0,0]
            //     }
            // }else{
            //     return [1,1]
            // }
            if(columnIndex === 1){
                return [1,15]
            }else if(columnIndex === 0){
                return [1,1]
            }else{
                return [0,0]
            }
        },
        async showDetail(){
            this.loading = true;
            await setTimeout(()=>{
                this.workData.map(item=>{
                    item._expanded = !item._expanded
                })
                this.isShowDetail = !this.isShowDetail;
            },0);
            this.loading = false;
        },
        getTemplateCode(val, list){
            if(val) return list.filter( item => item.id === val)[0].code;
        },
		async getDetail() {
            if(this.type == 'add') return;
			this.loading = true;
            await HttpCostQuotationDetail({
                id:this.id
            }).then(res=>{
                this.loading = false;
                this.formData = res.data;
                this.formData.warehouse = res.data.warehouseCode;
                this.formData.effectTime = res.data.startDate + ' ~ ' + res.data.endDate;
                let operateData = res.data.billingOperationPriceTemplateItemEntities;
                const workData = [];
                operateData.map(item=>{
                    let code = workData.find( data => data.id === item.orderType)
                    let name = this.getOrderList.find( obj => obj.value === item.orderType)
                    if(!code){
                        workData.push({id: item.orderType, billingCategoryCode: name.label, children1: [item], _expanded:true});
                    }else{
                        code.children1.push(item)
                    }
                })
                this.workData = workData;
                this.storageData = res.data.billingStoragePriceTemplateItemEntities;
                this.addedData = res.data.billingValueAddedPriceTemplateItemEntities;
                this.logList = res.data.orderLogEntityList || [];
            },err=>{
                this.loading = false;
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
		},
		close() {
			this.$router.push({
				name: 'costQuotationList'
			})
		},
		async submit() {
            const valid = await this.$refs.baseform.validate();
			if (!valid) return;
            let billingOperationPriceTemplateCode = this.getTemplateCode(this.formData.billingOperationPriceTemplateId, this.workListPay);
            let billingStoragePriceTemplateCode = this.getTemplateCode(this.formData.billingStoragePriceTemplateId, this.storageListPay);
            let billingValueAddedPriceTemplateCode = this.getTemplateCode(this.formData.billingValueAddedPriceTemplateId, this.addedListPay);
            let warehouse = this.warehouseList.filter( obj => obj.value === this.formData.warehouse)[0];
            let warehouseId = warehouse.attach.id;
            let warehouseCode = warehouse.value;
            let startDate = this.formData.effectTime.split('~')[0].trim();
            let endDate = this.formData.effectTime.split('~')[1].trim();
            const queryParams = {
                id: this.id,
                hostOrganizationId: global.SYSID,
                organizationId: this.formData.organizationId,
                warehouseId,
                warehouseCode,
                billingOperationPriceTemplateId: this.formData.billingOperationPriceTemplateId || 0,
                billingOperationPriceTemplateCode: billingOperationPriceTemplateCode || '',
                billingStoragePriceTemplateId: this.formData.billingStoragePriceTemplateId || 0,
                billingStoragePriceTemplateCode: billingStoragePriceTemplateCode || '',
                billingValueAddedPriceTemplateId: this.formData.billingValueAddedPriceTemplateId || 0,
                billingValueAddedPriceTemplateCode: billingValueAddedPriceTemplateCode || '',
                startDate,
                endDate
            };
			this.loading = true;
			HttpSaveCostQuotation(queryParams).then(res => {
                this.$Message.success({
                    content: res.message,
                    duration: 30,
                    closable: true,
                });
				this.close();
			}, err => {
				this.loading = false;
                this.$Message.error({
                    content: err.message,
                    duration: 30,
                    closable: true,
                });
			})
		}
	}
};
</script>
